module.exports = __webpack_public_path__ + "img/horizontal_4_7_0.022e67f9.png";